import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Stats from "@/components/Stats";
import Benefits from "@/components/Benefits";
import HowItWorks from "@/components/HowItWorks";
import Costs from "@/components/Costs";
import Calculator from "@/components/Calculator";
import TakesCare from "@/components/TakesCare";
import Blog from "@/components/Blog";
import Team from "@/components/Team";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { useEffect } from "react";
import { scrollToId } from "@/components/Nav";

export default function Home() {
  useEffect(() => {
    document.title = "Semplificaffitto.it - Affitto casa e immobili garantito - Firenze Scandicci";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "Semplificaffitto: la soluzione di gestione delle locazioni. In caso di morosità, indennizzo del 100% del canone fino a 3 mensilità, tutela legale e zero costi di intermediazione per il proprietario. Firenze e Scandicci.");
    const target = sessionStorage.getItem("scrollTo");
    if (target) {
      sessionStorage.removeItem("scrollTo");
      const t = setTimeout(() => scrollToId(target), 700);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <Stats />
      <Benefits />
      <HowItWorks />
      <Costs />
      <Calculator />
      <TakesCare />
      <Blog />
      <Team />
      <Faq />
      <Contact />
      <Footer />
    </main>
  );
}
